<template>
<div class="chapter">
<div class="inner_page">
<p class="title-head">CONTENTS</p>
<table>
<colgroup>
<col width="40px"/>
<col width="350px"/>
</colgroup>
<tbody>
<tr><td colspan="2"><span href="#/Title" title="Link target outside of Sample">Title Page</span></td></tr>
<tr><td colspan="2"><span href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></td></tr>
<tr><td colspan="2"><a href="#/Dedication">Dedication</a></td></tr>
<tr><td colspan="2"><a href="#/Acknowledgements#Ack">Acknowledgments</a></td></tr>
<tr><td colspan="2"><a href="#/Introduction#Intro">Introduction</a></td></tr>
<tr><td><span href="#/Chapter01#C1" title="Link target outside of Sample">1.</span></td><td><span href="#/Chapter01#C1" title="Link target outside of Sample">Once Upon A Hilltop</span></td></tr>
<tr><td><span href="#/Chapter02#C2" title="Link target outside of Sample">2.</span></td><td><span href="#/Chapter02#C2" title="Link target outside of Sample">The Sultan Arrives</span></td></tr>
<tr><td><span href="#/Chapter03#C3" title="Link target outside of Sample">3.</span></td><td><span href="#/Chapter03#C3" title="Link target outside of Sample">Joltin’ Joe, Leading Man</span></td></tr>
<tr><td><span href="#/Chapter04#C4" title="Link target outside of Sample">4.</span></td><td><span href="#/Chapter04#C4" title="Link target outside of Sample">The “Mantle” is Passed</span></td></tr>
<tr><td><span href="#/Chapter05#C5" title="Link target outside of Sample">5.</span></td><td><span href="#/Chapter05#C5" title="Link target outside of Sample">Mr. October Stirs New York</span></td></tr>
<tr><td><span href="#/Chapter06#C6" title="Link target outside of Sample">6.</span></td><td><span href="#/Chapter06#C6" title="Link target outside of Sample">The Captain and the Sandman</span></td></tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?28926808